import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    width: '100vw',
  },
  card: {
    width: '320px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    padding: '30px',
    margin: 'auto',
  },
  title: {
    textAlign: 'center',
    fontSize: '26px',
    fontWeight: 600,
    marginBottom: '16px',
  },
  error: {
    backgroundColor: '#fff0f0',
    color: '#e74c3c',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '15px',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    alignItems: 'center',
  },
  fieldContainer: {
    width: '300px',
  },
  fullInput: {
    width: '270px',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  rowContainer: {
    width: '300px',
    display: 'flex',
    gap: '10px',
  },
  emailInput: {
    width: '200px',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  sendButton: {
    width: '100px',
    padding: '0px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },
  button: {
    width: '300px',
    padding: '11px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    marginTop: '10px',
  },
};

function VerifyCode() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    code: '',
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendCode = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const preferredLanguage =
        localStorage.getItem('selectedLanguage') || 'zh';
      const res = await axios.post('/api/send-verify-code', {
        username: formData.username,
        email: formData.email,
        preferredLanguage,
      });
      setMessage(res.data.message);
    } catch (err) {
      setMessage(err.response?.data?.message || '發送失敗');
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setMessage('');
    if (!formData.username || !formData.email || !formData.code) {
      setMessage('請填寫所有欄位');
      return;
    }
    try {
      const res = await axios.post('/api/verify-code', {
        username: formData.username,
        email: formData.email,
        code: formData.code,
      });
      setMessage(res.data.message);
      if (res.status === 200 && res.data.token) {
        navigate('/reset-password', {
          state: { username: formData.username, token: res.data.token },
        });
      }
    } catch (err) {
      setMessage(err.response?.data?.message || '驗證失敗');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{t('forgotPassword')}</h2>
        {message && <div style={styles.error}>{message}</div>}
        <form style={styles.form}>
          <div style={styles.fieldContainer}>
            <input
              style={styles.fullInput}
              type="text"
              name="username"
              placeholder={t('enterUsername')}
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div style={styles.rowContainer}>
            <input
              style={styles.emailInput}
              type="email"
              name="email"
              placeholder={t('enterEmail')}
              value={formData.email}
              onChange={handleChange}
              required
            />
            <button
              type="button"
              style={styles.sendButton}
              onClick={handleSendCode}
            >
              {t('sendVerificationCode')}
            </button>
          </div>
          <div style={styles.fieldContainer}>
            <input
              style={styles.fullInput}
              type="text"
              name="code"
              placeholder={t('enterVerificationCode')}
              value={formData.code}
              onChange={handleChange}
              required
            />
          </div>
          <button style={styles.button} onClick={handleVerify}>
            {t('confirm')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default VerifyCode;
